var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1249 12.1666H13.8541C13.3593 12.1666 12.9583 12.5677 12.9583 13.0625V43.5208C12.9583 44.0156 13.3593 44.4166 13.8541 44.4166H38.9374C39.4322 44.4166 39.8332 44.0156 39.8332 43.5208V13.0625C39.8332 12.5677 39.4322 12.1666 38.9374 12.1666H32.6666",
    stroke: "#335C75",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 16.6458V12.1667H23.664C23.6884 12.1667 23.7083 12.1468 23.7083 12.1223V10.375C23.7083 8.89074 24.9115 7.6875 26.3958 7.6875C27.8801 7.6875 29.0833 8.89074 29.0833 10.375V12.1223C29.0833 12.1468 29.1032 12.1667 29.1277 12.1667H32.6667V16.6458C32.6667 17.1406 32.2656 17.5417 31.7708 17.5417H21.0208C20.5261 17.5417 20.125 17.1406 20.125 16.6458Z",
    stroke: "#335C75",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotepad);
export default __webpack_public_path__ + "static/media/icon-notepad.5426ccd67e007d35b77287182a7bd907.svg";
export { ForwardRef as ReactComponent };